import { useEffect, useState } from 'react'

const STORAGE_KEY = 'pageSize'

export default function usePersistedPageSize(defaultSize = 32) {
  const [pageSize, setPageSize] = useState(() => {
    // 初始值從 localStorage 讀取
    if (typeof window !== 'undefined') {
      const stored = localStorage.getItem(STORAGE_KEY)
      return stored ? parseInt(stored, 10) : defaultSize
    }
    return defaultSize
  })

  useEffect(() => {
    // 每次變更時更新 localStorage
    localStorage.setItem(STORAGE_KEY, pageSize)
  }, [pageSize])

  return [pageSize, setPageSize]
}
